<ng-template #takeOffPitchPopoverTemplate>
    <div>
        <div class="row padding-10">
            <label>Degrees</label>
            <input
                legacy-css
                type="text"
                appNumeric
                decimals="2"
                max="89"
                appSelectAllOnFocus
                [(ngModel)]="degrees"
                [ngModelOptions]="{ standalone: true }"
                class="form-control width-60"
                (ngModelChange)="onDegreesChanged()" />
        </div>
        <div class="row padding-10">
            <section style="display: inline-flex">
                <div style="flex: content">
                    <label>Rise</label>
                    <input
                        legacy-css
                        type="text"
                        appNumeric
                        decimals="0"
                        max="99"
                        appSelectAllOnFocus
                        [(ngModel)]="ratioX"
                        [ngModelOptions]="{ standalone: true }"
                        class="form-control width-60"
                        (ngModelChange)="onRatioXYChanged()" />
                </div>
                <div style="flex: content" class="min-width-25 padding-top-30 text-center">:</div>
                <div style="flex: content">
                    <label>Run</label>
                    <input
                        legacy-css
                        type="text"
                        appNumeric
                        decimals="0"
                        max="99"
                        appSelectAllOnFocus
                        [(ngModel)]="ratioY"
                        [ngModelOptions]="{ standalone: true }"
                        class="form-control width-60"
                        (ngModelChange)="onRatioXYChanged()" />
                </div>
            </section>
            <p class="text-danger text-small">{{ ratioError }}</p>
        </div>
    </div>
</ng-template>

@if (isNewView) {
    <button
        type="button"
        id="toPitchDropdown"
        class="btn-bx-secondary-stroked degrees"
        [ngClass]="{ 'border-radius-left': isHeader() }"
        tooltip="Angle / Surface Pitch"
        placement="bottom"
        [popover]="takeOffPitchPopoverTemplate"
        [outsideClick]="true"
        popoverTitle="Enter the degrees or rise over run:"
        container="body"
        [disabled]="disabled">
        <strong>{{ degrees }}&deg;</strong>
    </button>
} @else {
    <button
        type="button"
        id="toPitchDropdown"
        class="btn take-off-pitch-dropdown-btn"
        tooltip="Angle / Surface Pitch"
        placement="bottom"
        [popover]="takeOffPitchPopoverTemplate"
        [outsideClick]="true"
        popoverTitle="Enter the degrees or rise over run:"
        container="body"
        [ngClass]="{ 'btn-light-azure': degrees, 'btn-dark-blue': !degrees }">
        <i class="fa fa-chevron-up text-large margin-right-5"> </i>
        <strong>{{ degrees }} &deg;</strong>
    </button>
}
